import Vue from "vue";
import Vuex from 'vuex'
import staff from "@/store/staff";
import token from "@/store/token";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        staff, token
    }
})